import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import Header from './components/Header';
import MobileNav from './components/MobileNav';
import { ToastContainer, useToast } from './components/Toast';
import { LoginModal, RegisterModal } from './components/AuthModals';
import Landing from './pages/Landing';
import Marketplace from './pages/Marketplace';
import Suppliers from './pages/Suppliers';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import AIInsights from './pages/AIInsights';
import { HowItWorks, About, Contact } from './pages/StaticPages';

export default function App() {
  const { user, loading } = useAuth();
  const { toast } = useToast();
  const [activeTab, setActiveTabState] = useState(() => {
    return sessionStorage.getItem('sa_active_tab') || 'landing';
  });
  const [authModal, setAuthModal] = useState(null); // 'login' | 'register'

  const setActiveTab = (tab) => {
    setActiveTabState(tab);
    try {
      sessionStorage.setItem('sa_active_tab', tab);
    } catch {}
  };

  const navTo = (tab) => {
    if (tab === 'dashboard' && !user) {
      toast('Login required to access your Dashboard & Quote Tracker', 'error'); setAuthModal('login'); return;
    }
    if (tab === 'admin' && user?.role !== 'admin') {
      toast('Admin access only', 'error'); return;
    }
    setActiveTab(tab);
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#111' }}>
        <div style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
          <i className="fas fa-spinner fa-spin" style={{ fontSize: '2rem', color: 'var(--yellow)' }}></i>
          <div style={{ marginTop: '0.75rem', fontSize: '0.875rem' }}>Loading SAsuppliers...</div>
        </div>
      </div>
    );
  }

  const isRegisterOpen = authModal === 'register' || (typeof authModal === 'object' && authModal?.type === 'register');
  const registerInitialRole = typeof authModal === 'object' && authModal?.role ? authModal.role : (authModal === 'register_supplier' ? 'supplier' : 'buyer');

  return (
    <>
      <Header
        activeTab={activeTab}
        setActiveTab={navTo}
        onLogin={() => setAuthModal('login')}
        onRegister={(role) => setAuthModal({ type: 'register', role: role || 'supplier' })}
      />

      <main>
        {activeTab === 'landing' && <Landing setActiveTab={navTo} onRegister={(role) => setAuthModal({ type: 'register', role: role || 'supplier' })} />}
        {activeTab === 'marketplace' && <Marketplace setActiveTab={navTo} />}
        {activeTab === 'ai-insights' && <AIInsights setActiveTab={navTo} />}
        {activeTab === 'suppliers' && <Suppliers />}
        {activeTab === 'dashboard' && <Dashboard />}
        {activeTab === 'admin' && <Admin />}
        {activeTab === 'how-it-works' && <HowItWorks setActiveTab={navTo} onRegister={(role) => setAuthModal({ type: 'register', role: role || 'supplier' })} />}
        {activeTab === 'about' && <About setActiveTab={navTo} />}
        {activeTab === 'contact' && <Contact />}
      </main>

      <MobileNav activeTab={activeTab} setActiveTab={navTo} onLogin={() => setAuthModal('login')} />

      {authModal === 'login' && (
        <LoginModal
          onClose={() => setAuthModal(null)}
          onSwitchRegister={() => setAuthModal('register')}
        />
      )}
      {isRegisterOpen && (
        <RegisterModal
          initialRole={registerInitialRole}
          onClose={() => setAuthModal(null)}
          onSwitchLogin={() => setAuthModal('login')}
          onSupplierRegistered={(registeredUser) => {
            setActiveTab('dashboard');
            toast('Welcome! Complete your verification and subscription setup to activate your listings.', 'info');
          }}
        />
      )}

      <ToastContainer />
    </>
  );
}
